module.exports = __webpack_public_path__ + "static/media/adult.2e37fb9b.csv";